import { Component } from '@angular/core';

@Component({
  selector: 'app-container',
  template: `<div class="tw-container tw-mx-auto tw-w-full tw-h-full tw-px-4">
    <ng-content></ng-content>
  </div>`,
})
export class ContainerComponent {}
